<template>
  <div class="donation-blue-saldo-field">
    <div>{{ type }} BETALING: € {{ amount }}</div>
  </div>
</template>

<script>
export default {
  created() {},
  computed: {
    type: function () {
      return this.$store.state.payment_info.type_payment == "eenmalig"
        ? "EENMALIGE"
        : "PERIODIEKE"
    },
    amount: function () {
      return (
        (Math.round(this.$store.state.payment_info.amount * 100) / 100).toFixed(2) + ""
      ).replace(".", ",")
    },
  },
}
</script>

<style scoped>
.donation-blue-saldo-field {
  margin-top: 5%;
}
</style>
